import React from "react";
import { motion } from "framer-motion";

interface ProgressBarProps {
  steps: string[];
  currentStep: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ steps, currentStep }) => {
  const progress = (currentStep / (steps.length - 1)) * 100;

  return (
    <div className="w-full flex flex-col space-y-1">
      {/* Progress line */}
      <div className="relative w-full h-1 bg-gray-200 rounded-lg overflow-hidden">
        <motion.div
          className="absolute top-0 left-0 h-2 bg-purple-600 rounded-full"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.5 }}
        />

        {/* Step markers */}
        <div className="absolute top-1/2 left-0 w-full flex justify-between transform -translate-y-1/2 px-[2px]">
          {steps.map((_, index) => (
            <div
              key={index}
              className={`w-2.5 h-2.5 rounded-full border-2 transition-all duration-300 ${
                index <= currentStep
                  ? "bg-white border-[3px] border-purple-600"
                  : "bg-gray-200 border-gray-300"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
